import { ReactNode } from "react";
import { Card } from "../../../components/Card/Card";
import styles from "./SectionCard.module.css";

interface Props {
  id: string;
  title: string;
  apiName: string;
  dirty?: boolean;
  /**
   * A banner ABOVE the description — the one place a section can say
   * something about the server rather than about the project. The Cloud
   * saves card puts its «no bucket on this server» warning here.
   */
  notice?: ReactNode;
  description?: ReactNode;
  children: ReactNode;
}

/**
 * Section card used by ProjectConfigPage. Wraps the platform `<Card>` with
 * a custom header (h3 + mod-dot + right-aligned api-name) and a body that
 * renders an optional description above the field-rows.
 *
 * Mockup: project-config.html L448-L516 (and analogous per-section blocks).
 */
export function SectionCard({
  id,
  title,
  apiName,
  dirty,
  notice,
  description,
  children,
}: Props) {
  return (
    <Card id={id} className={styles.section}>
      <div className={styles.header}>
        <h3 className={styles.title}>
          {title}
          {dirty && (
            <span
              className={styles.modDot}
              aria-label="Section has unsaved changes"
              title="Modified"
            />
          )}
        </h3>
        <span className={styles.apiName}>{apiName}</span>
      </div>
      <div className={styles.body}>
        {notice && <div className={styles.notice}>{notice}</div>}
        {description && <p className={styles.desc}>{description}</p>}
        {children}
      </div>
    </Card>
  );
}
